export const locales = (locale) => (
  require(`./${locale}/translation.json`)
)
